import { Locale } from "next/router";

import { HELP_ROUTE } from "@/common/static/routes.static";
import { withLocale } from "@/common/utils/url.utils";
import { defaultLocale } from "@/i18n/config";

export const getHelpPath = () => HELP_ROUTE;

export const getHelpCategoryPath = (categorySlug: string) =>
  `${HELP_ROUTE}/${categorySlug}`;

export const getHelpArticlePath = (categorySlug: string, articleSlug: string) =>
  `${HELP_ROUTE}/${categorySlug}/${articleSlug}`;

export const getHelpSearchPath = (query?: string) => {
  if (!query) {
    return `${HELP_ROUTE}/search`;
  }

  return `${HELP_ROUTE}/search?q=${encodeURIComponent(query)}`;
};

export const getHelpPathForLocale = (locale?: Locale) =>
  withLocale(HELP_ROUTE, locale, defaultLocale);

export const getHelpCategoryPathForLocale = (
  categorySlug: string,
  locale?: Locale
) => withLocale(getHelpCategoryPath(categorySlug), locale, defaultLocale);

export const getHelpArticlePathForLocale = (
  categorySlug: string,
  articleSlug: string,
  locale?: Locale
) =>
  withLocale(
    getHelpArticlePath(categorySlug, articleSlug),
    locale,
    defaultLocale
  );
